'use client';

import { useQuery } from '@tanstack/react-query';

import { getCertificateListService } from '@/services/httpServices/CertificateServices';
import type { CertificateListServiceConfig } from '@/services/httpServices/CertificateServices/types';

import { certificateListKeys } from './useCertificateQueryKeys';
import { useQueryConfig } from './useQueryConfig';

export function useCertificateListQuery(params: CertificateListServiceConfig) {
  const { isEnabled } = useQueryConfig();

  return useQuery({
    queryKey: certificateListKeys(params),
    queryFn: async () => getCertificateListService(params),
    enabled: isEnabled,
  });
}
